import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';

export const setClientErrorResolution = createAsyncThunk(
    'clientErrors/setClientErrorResolution',
    async (params: { id: number; isResolved: boolean }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.put(`/api/ClientErrorReports/${params.id}/resolution`, {
            isResolved: params.isResolved,
        });

        if (response.status !== 200) {
            createNotification('Could not update the error report at the moment.', 'error');
            throw new Error('Failed to update client error report resolution');
        }

        return { id: params.id };
    }
);
